'use client'

import { DocsBreadcrumb } from '@/components/DocsBreadcrumb'
import { SkipNavContent } from 'nextra/components'
import { ClientWrapper, TOCProvider } from '../lib/nextra-theme-internals'
import { CopyButton } from './CopyButton'
import { SidebarTrigger } from './ui/sidebar'

export function DocsWrapper(props) {
  const { toc, children, metadata, bottomContent, sourceCode, ...rest } = props

  return (
    <TOCProvider value={toc}>
      <ClientWrapper metadata={metadata} bottomContent={bottomContent} {...rest}>
        {sourceCode ? <CopyButton sourceCode={sourceCode} /> : null}
        <SkipNavContent />
        <div className="flex items-center gap-4 mb-6 w-[calc(100%-6rem)]">
          <SidebarTrigger className="z-10 shrink-0 border border-(--color-border-subtle)! bg-(--color-hover-bg)! text-(--color-foreground)!" />
          <DocsBreadcrumb />
        </div>
        <main data-pagefind-body={metadata.searchable !== false || void 0}>{children}</main>
      </ClientWrapper>
    </TOCProvider>
  )
}
